"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DonutChart = void 0;

var _d3Interpolate = require("d3-interpolate");

var _d3Shape = require("d3-shape");

var _react = _interopRequireWildcard(require("react"));

var _renderprops = require("react-spring/renderprops.cjs");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _Box = require("../Box");

var _ChartHoverTooltip = require("../DataVis/ChartHoverTooltip");

var _ChartTooltip = require("../DataVis/ChartTooltip");

var _MousePositionContext = require("../DataVis/MousePositionContext");

var _useHasEnteredViewPort = require("../DataVis/utils/useHasEnteredViewPort");

var _useWrapperWidth = require("../DataVis/utils/useWrapperWidth");

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var colors = ["black10", "black30", "black60"];
var MIN_CHART_SIZE = 30;

/**
 * DonutChart is a component that displays data points with donut shaped arcs.
 * Good for illustrating numerical proportions.
 */
var DonutChart = function DonutChart(_ref) {
  var points = _ref.points,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? (0, _helpers.space)(3) : _ref$margin;

  var _useState = (0, _react.useState)(-1),
      _useState2 = _slicedToArray(_useState, 2),
      hoverIndex = _useState2[0],
      setHoverIndex = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      labelFadeIn = _useState4[0],
      setLabelFadeIn = _useState4[1];

  var wrapperRef = (0, _react.useRef)(null);
  var hasEnteredViewport = (0, _useHasEnteredViewPort.useHasEnteredViewport)(wrapperRef);
  var width = Math.max((0, _useWrapperWidth.useWrapperWidth)(wrapperRef), MIN_CHART_SIZE); // width of the arc is %12 of chart width

  var donutWidth = width * 0.12; // margin between chart and labels step down to 10px when chart is smaller than 230px

  var donutLabelMargin = width > 230 ? (0, _helpers.space)(2) : (0, _helpers.space)(1); // 2px in radians

  var padAngel = Math.atan(2 / width);
  var centerX = width / 2 + margin;
  var centerY = width / 2 + margin;
  var values = points.map(function (d) {
    return d.value;
  });
  var angelInterpolator = (0, _d3Interpolate.interpolate)(0, 2 * Math.PI);
  var arc = (0, _d3Shape.arc)().innerRadius(width / 2 - margin - donutWidth).outerRadius(width / 2 - margin).padAngle(padAngel); // virtual donut to use its arc centroids to calculate label position

  var labelArc = (0, _d3Shape.arc)().innerRadius(width / 2 - margin + donutLabelMargin).outerRadius(width / 2 - margin + donutLabelMargin);
  var pie = (0, _d3Shape.pie)().value(function (d) {
    return d.value;
  });
  var tooltip = points.map(function (point, index) {
    var hover = hoverIndex === index;
    return hover ? _react.default.createElement(_ChartHoverTooltip.ChartHoverTooltip, {
      key: "".concat(index, "-hover")
    }, (0, _ChartTooltip.coerceTooltip)(point.tooltip)) : null;
  });
  var labels = pie(points).map(function (slice, index) {
    var _labelArc$centroid = labelArc.centroid(slice),
        _labelArc$centroid2 = _slicedToArray(_labelArc$centroid, 2),
        x = _labelArc$centroid2[0],
        y = _labelArc$centroid2[1];

    var axisLabelX = points[index].axisLabelX;
    return axisLabelX && _react.default.createElement(DonutLabelContainer, {
      key: index,
      opacity: labelFadeIn ? 1 : 0,
      x: x + centerX,
      y: y + centerY,
      center: centerX
    }, _react.default.createElement(_Typography.Sans, {
      color: "black60",
      size: "2"
    }, (0, _ChartTooltip.coerceTooltipWithoutPadding)(axisLabelX)));
  });
  var zeroStateArc = pie([{
    value: 1
  }]).map(function (zeroState) {
    return _react.default.createElement("path", {
      key: "zero-state",
      stroke: "none",
      fill: (0, _helpers.color)("black5"),
      d: arc(zeroState)
    });
  });

  var animateProps = function animateProps(e) {
    return {
      num: e ? 0 : 1
    };
  };

  var svg = _react.default.createElement("svg", {
    key: "svg",
    width: width + margin,
    height: width + margin
  }, _react.default.createElement("g", {
    transform: "translate(".concat(centerX, ", ").concat(centerY, ")")
  }, zeroStateArc, _react.default.createElement(_renderprops.Spring, {
    from: {
      num: -0.1
    },
    to: animateProps(!hasEnteredViewport)
  }, function (_ref2) {
    var num = _ref2.num;

    if (!labelFadeIn && num > 0.7) {
      setLabelFadeIn(true);
    }

    var angle = angelInterpolator(num);
    pie.endAngle(angle);
    var slices = pie(points).map(function (datum, index) {
      // d3 by default sorts slices by values. for color assignment we
      // need sorted index but for hover we need original order in points
      // to match with correct tooltip
      var sortedIndex = datum.index;
      var arcColor = (0, _helpers.color)(colors[sortedIndex % colors.length]); // avoid the first and last arc ending up the same color

      if (sortedIndex === values.length - 1 && sortedIndex % colors.length === 0) {
        arcColor = (0, _helpers.color)(colors[1]);
      }

      return _react.default.createElement("path", {
        key: index,
        fill: arcColor,
        d: arc(datum),
        onMouseEnter: function onMouseEnter() {
          return setHoverIndex(index);
        },
        onMouseLeave: function onMouseLeave() {
          return setHoverIndex(-1);
        }
      });
    });
    return _react.default.createElement("g", null, slices);
  })));

  return _react.default.createElement(_MousePositionContext.ProvideMousePosition, null, _react.default.createElement(_Box.Box, {
    ref: wrapperRef,
    position: "relative"
  }, _react.default.createElement(_react.default.Fragment, null, tooltip, width !== MIN_CHART_SIZE && labels, svg)));
};

exports.DonutChart = DonutChart;
DonutChart.displayName = "DonutChart";

// to create a float:right effect for labels that are on left side (also top)
var computeLabelTranslate = function computeLabelTranslate(dim, center) {
  var diffPercent = (dim - center) / center;

  if (diffPercent < -0.25) {
    return "-100%";
  } else if (diffPercent < -0 && diffPercent > -0.25) {
    return "-50%";
  } else {
    return "0";
  }
};

var DonutLabelContainer = _styledComponents.default.div.withConfig({
  displayName: "DonutChart__DonutLabelContainer",
  componentId: "w36xxr-0"
})(["top:", "px;left:", "px;position:absolute;text-align:center;transform:translate( ", ",", " );white-space:nowrap;transition:opacity 0.4s ease-in;opacity:", ";"], function (_ref3) {
  var y = _ref3.y;
  return y;
}, function (_ref4) {
  var x = _ref4.x;
  return x;
}, function (_ref5) {
  var x = _ref5.x,
      center = _ref5.center;
  return computeLabelTranslate(x, center);
}, function (_ref6) {
  var y = _ref6.y,
      center = _ref6.center;
  return computeLabelTranslate(y, center);
}, function (_ref7) {
  var opacity = _ref7.opacity;
  return opacity;
});
//# sourceMappingURL=DonutChart.js.map